import virtualizationReducer from "./reducers";

export {
  fetchVMsListStart,
  fetchTaskStatusListStart,
  createVMTaskStart,
  controlVMStart,
  deleteVMStart,
  fetchVIRTRecoveryPointsStart,
  updateVMConfigurationsStart,
  rebuildVMStart,
  fetchVirtUserInfoStart,
  closeSSEConnection,
  logoutVirtInstances,
  handleRPCConsoleAccessStart,
  handleRPCBootProgressStart
} from "./operations";
export default virtualizationReducer;
